import React, { useEffect, useState } from "react";
import {
  SunIcon,
  MoonIcon,
  Bars3Icon,
  XMarkIcon,
} from "@heroicons/react/24/solid";
import Logo from "../logo.svg";

export default function AnimatedNavbar() {
  const [dark, setDark] = useState(() => {
    const saved = localStorage.getItem("theme");
    return saved
      ? saved === "dark"
      : window.matchMedia("(prefers-color-scheme: dark)").matches;
  });
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (dark) {
      root.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      root.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [dark]);

  return (
    <header
      className={`fixed w-full z-50 transition-all ${
        scrolled
          ? "backdrop-blur bg-white/80 dark:bg-gray-900/70 shadow-sm py-2"
          : "bg-transparent py-4"
      }`}
    >
      <nav className="container mx-auto px-4 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-2">
          <img src={Logo} alt="Logo" className="h-8 w-8 rounded-md" />
          <span className="text-xl font-semibold text-gray-900 dark:text-white">
            MyPortfolio
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-8 text-gray-800 dark:text-gray-200 font-medium">
          <li>
            <a href="#home" className="hover:text-blue-500">
              Home
            </a>
          </li>
          <li>
            <a href="#about" className="hover:text-blue-500">
              About
            </a>
          </li>
          <li>
            <a href="#skills" className="hover:text-blue-500">
              Skills
            </a>
          </li>
          <li>
            <a href="#portfolio" className="hover:text-blue-500">
              Projects
            </a>
          </li>
          <li>
            <a href="#contact" className="hover:text-blue-500">
              Contact
            </a>
          </li>
        </ul>

        <div className="flex items-center gap-3">
          <button
            onClick={() => setDark((d) => !d)}
            aria-label="Toggle theme"
            aria-pressed={dark}
            className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 hover:scale-110 transition-transform"
          >
            {dark ? (
              <SunIcon className="h-6 w-6 text-yellow-400" />
            ) : (
              <MoonIcon className="h-6 w-6 text-gray-800 dark:text-gray-200" />
            )}
          </button>
          <button
            onClick={() => setOpen((o) => !o)}
            className="md:hidden p-2 rounded-md text-gray-800 dark:text-gray-200"
          >
            {open ? (
              <XMarkIcon className="h-7 w-7" />
            ) : (
              <Bars3Icon className="h-7 w-7" />
            )}
          </button>
        </div>
      </nav>
      {open && (
        <div className="md:hidden border-t border-gray-200/60 dark:border-white/10 bg-white dark:bg-gray-900">
          <ul className="container mx-auto px-4 py-3 flex flex-col gap-2 text-gray-800 dark:text-gray-200 font-medium">
            <li>
              <a href="#home" onClick={() => setOpen(false)}>
                Home
              </a>
            </li>
            <li>
              <a href="#about" onClick={() => setOpen(false)}>
                About
              </a>
            </li>
            <li>
              <a href="#skills" onClick={() => setOpen(false)}>
                Skills
              </a>
            </li>
            <li>
              <a href="#portfolio" onClick={() => setOpen(false)}>
                Projects
              </a>
            </li>
            <li>
              <a href="#contact" onClick={() => setOpen(false)}>
                Contact
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
